import React, { Component } from 'react';

import { fetchDefaultData, saveUserData } from './State/actions/sessions';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { redirection_Link } from './AppConfig';
import App from 'grommet/components/App';
//import Header from 'grommet/components/Header';
import Box from 'grommet/components/Box';
//import Headline from 'grommet/components/Headline';
import Heading from 'grommet/components/Heading';
//import BrandHpeStack from 'grommet/components/icons/base/BrandHpeStack';
import Spinning from 'grommet/components/icons/Spinning'
import Layer from 'grommet/components/Layer';
import Revert from 'grommet/components/icons/base/Revert';
import Home from './SizingEngineUI/SizingEngineCommonScreens/Home';
import Build from './SizingEngineUI/SizingEngineCommonScreens/Build';
//import Login from './SizingEngineUI/SizingEngineCommonScreens/Login';
import { appUrl, said, landingUrl, logOutAttribute } from './AppConfig';
import Beforeunload from 'react-beforeunload/lib/Beforeunload';
//import Base64 from 'base-64';
import queryString from 'query-string'
// import LoginScr from './SizingEngineUI/UsherScreens/LoginForm';
// import RegistrationScr from './SizingEngineUI/UsherScreens/RegistrationForm';
// import ResetPasswordScr from './SizingEngineUI/UsherScreens/ResetPassword';
// import ForgotPasswordScr from './SizingEngineUI/UsherScreens/ForgotPassword';
// import ValidateUserScr from './SizingEngineUI/UsherScreens/ValidateUser';

import createBrowserHistory from 'history/createBrowserHistory'
import $ from 'jquery';
import { title, basename, serviceUrl } from './AppConfig';

//import Cookies from 'grommet/utils/Cookies';
import Button from 'grommet/components/Button';
import Paragraph from 'grommet/components/Paragraph';
import { checkLogin, getUserBasicInfo, login, ssoLogin } from './State/actions/authentication';
import { updateCountry } from './State/actions/sessions';
import IdleTimer from 'react-idle-timer'
import ProgressBar from './SizingEngineUI/SizingEngineCommonScreens/SizingProgressbar'
import GraphicalRepresentation from './SizingEngineUI/SizingEngineCommonScreens/GraphicalRepresentation';
import SolutionPreview from './SizingEngineUI/SizingEngineCommonScreens/SolutionPreview';
import CompareSol from './SizingEngineUI/SizingEngineCommonScreens/CompareSol';
import {redirectToSSET,clearSSETDataAndRedirect} from './SizingEngineUI/SizingEngineCommonScreens/Utils';
import MetricsData_vNext from './SizingEngineUI/SizingEngineCommonScreens/MetricsData_vNext';
import SAPLOOKUP from './SizingEngineUI/SizingEngineCommonScreens/SAPLOOKUP';
import GLGROWTH from './SizingEngineUI/SizingEngineCommonScreens/GlGrowth';
import windowListener from 'react-tooltip/dist/decorators/windowListener';
import Anchor from 'grommet/components/Anchor';
import * as CONSTANTS from './State/constants/CommonConstants';

const tRUE_ = "true";


function SolutionLayout(props){
  return<Layer className="GRPage" /* closer={true} */ flush={false}  style={{ zIndex: 101 }} >
  <GraphicalRepresentation externalAppProps={props.grProps} isFromExternalApp={true} listItem={false} actvSoln={'Traditional'} />
</Layer> 
}

function renderSolutionPreview(props) {
  return <Layer className="GRPage" flush={false} style= {{ zIndex: 101}}>
    <SolutionPreview externalAppProps={props.solutionPreviewProps} isFromExternalApp={true} />
  </Layer>
}
function renderCompareSol(props) {
  return <Layer className="GRPage" flush={false} style= {{ zIndex: 101}}>
    <CompareSol externalAppProps={props.compareSolProps} isFromExternalApp={true} />
  </Layer>
}

function renderMetricsData(props) {
  return <Layer className="GRPage" flush={false} style= {{ zIndex: 101}}>
    <Button id="backToSSETyes" primary={false} plain={true} style={{position:'absolute',right:'0',color:'#ff8d6d'}}  /* icon={<Revert size="small" colorIndex='accent-3' />} */ label='Close' onClick={()=>{window.location.replace(props.metricsDataProps.ssetUrl);}} className="ReverseSavewrkloadbtn" />
  <MetricsData_vNext externalAppProps={props.metricsDataProps} isFromExternalApp={true} />
</Layer>
}

function renderSAPLookUp(props) {
  return <Layer className="SAPLookuplayer" style={{ overflow: "hidden" }}>
  <SAPLOOKUP externalAppProps={props.SAPLookUpProps} isFromExternalApp={true} />
</Layer>
}

function renderGLGROWTH(props) {
  return <Layer className="GRPage" flush={false} style= {{ zIndex: 101}}>
  <GLGROWTH externalAppProps={props.GlGrowthProps} isFromExternalApp={true} />
</Layer>
}

// var globalVariableForCount=0;
const history = createBrowserHistory();
let idletimeoutpopup = false;
let redirectUrlSSO = '';
let ssetURL ='';
let continueToSSET = 'False';
let hideforSSET = 'False';
class MyApp extends Component {

  constructor() {
    super();
    this.state = {
      MainFooter: true, isLoading: true, isAuthenticated: false, idleTimer: null, token: '', showGRView: false, grProps: {},
      showSolutionPreview: false,
      solutionPreviewProps : {},
      showMetricsData: false,
      metricsDataProps : {},
      showSAPLookUp : false,
      SAPLookUpProps : {},
      showCompareSol: false,
      compareSolProps : {},
      showGlGrowth: false,
      GlGrowthProps : {}
    };
    this.checkAuthentication = this.checkAuthentication.bind(this);
    this.setUserDefaultCountry = this.setUserDefaultCountry.bind(this);
    this.onIdle = this._onIdle.bind(this)
    this.Refresh = this.Refresh.bind(this)
    this.validateSSOUser = this.validateSSOUser.bind(this);
    this.reloadListener();
  }
  Refresh() {
    if (this.props.sessionsState.SSETid) {
      let id = this.props.sessionsState.activeSession.alias.split("#")[1];
      let isReviewed = this.props.sessionsState.ssetConfigurations.reviewed;       
       redirectToSSET(id, isReviewed);
      }    
    else {
      window.location = appUrl;
    }
  }

  _onIdle(e) {
    idletimeoutpopup = true;
    this.setState({})
  }

  getDefaultUser() {
    return {
      userName: 'default',
      lastName: 'default',
      password: undefined,
      preferredLanguage: 'en',
      hpclname: 'default@test.com',
      //hpclname:'test@hpe.com',
      hpclidnumber: 'd56c5196274c7f1bc5a6093c79e1822e',
      hpresidentcountrycode: 'US',
      email: 'default@test.com',
      createtimestamp: '2019-01-30 13:22:03',
      modifytimestamp: '2019-01-30 13:22:03',
      clang: 'US-en',
    }
  }
  componentDidMount() {
    $("title").text(title);
    this.checkAuthentication();
    if(ssetURL===''){
      let queryParam = queryString.parse(window.location.search);
      if(queryParam!==undefined && queryParam.reference!==undefined)
         hideforSSET = 'True';
        else
        hideforSSET = 'False';
      this.getSSETURL();
    }

    var queryParameter = queryString.parse(window.location.search);
    if(queryParameter!=="" && queryParameter.showGr=== tRUE_ || queryParameter.showPreview === tRUE_ || queryParameter.showMetricsData === tRUE_ || queryParameter.showLookUp === tRUE_ || queryParameter.COMPARESOLUTION === tRUE_)
    {
      let data = {
        sizerReference : queryParameter.sizerReference,
        ssetUrl:queryParameter.ssetUrl+window.location.hash
      }
      if (queryParameter.showGr === tRUE_) {
        this.setState({showGRView:true});
        this.setState({grProps:data});
      } else if (queryParameter.showPreview === tRUE_) {
        this.setState({ showSolutionPreview: true });
        this.setState({ solutionPreviewProps: data });
      } else if (queryParameter.showMetricsData === tRUE_) {
        this.setState({showMetricsData : true, metricsDataProps : data});
      } else if (queryParameter.showLookUp === tRUE_) {
        this.setState({showSAPLookUp: true, SAPLookUpProps : data});
      } else if(queryParameter.COMPARESOLUTION === tRUE_ && window.location.href.toUpperCase().indexOf("SYNERGYSIZER") > -1) {              
        this.setState({ showGlGrowth: true });
        this.setState({ GlGrowthProps: data });
      } else if (queryParameter.COMPARESOLUTION === tRUE_) {
        this.setState({ showCompareSol: true });
        this.setState({ compareSolProps: data });
      }
    }

     if(document.referrer=== "")
      window.sessionStorage.setItem("IsParent","True");

     document.title = CONSTANTS.SSETTITLE;

    // this.props.fetchDefaultData();    

    //  this.validateSSOUser(serviceUrl + 'SizingEngine/Gettoken','token')
    //  .then((result)=> {
    //         this.setState({ token: result.antiForgeryToken });           
    //         this.checkAuthentication();
    //         this.props.fetchDefaultData();  
    //  }); 
    // fetch(serviceUrl + 'SizingEngine/Gettoken',{
    //       method: "GET",
    //       headers: {
    //         'Accept': 'application/json',
    //         'Content-Type': 'application/json',
    //         'Cache': 'no-cache'
    //       },
    //       credentials: 'same-origin'
    //     })
    //   .then(function (response) {
    //     return response.json();
    //   })
    //   .then(function (myJson) {
    //     this.setState({ token: myJson.antiForgeryToken });           
    //     this.checkAuthentication();
    //     this.props.fetchDefaultData();  
    //   }.bind(this));      
    //this.props.fetchDefaultData();
  }

  getSSETURL(){
    let tokenUrl = 'SizingEngine/GetconfigDetails';
    let type = 'urlToken';
    let url = serviceUrl+tokenUrl;
    this.fetchSSETURL(url,type).then((result)=>{
      console.log(result);
      ssetURL = result.redirectToken+'UsherAPI';
      continueToSSET = result.continuetoSSETToken;
      window.sessionStorage.setItem("featureFlag",result.continuetoSSETToken);
      window.sessionStorage.setItem("ssetURL",result.redirectToken);
    })
  }
  fetchSSETURL(url,type){
    return new Promise((resolve,reject)=>{
      fetch(url,{
        method:'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Cache': 'no-cache'
        },
        credentials: 'same-origin'
      }).then(function(response){
        console.log(response);
        if(!response.ok){
          throw Error(response.statusText)
        }if (type === 'urlToken') {
          let data = {};
          data.redirectToken = response.headers.get('redirectToken');
          data.continuetoSSETToken = response.headers.get('continueRedirectToken');
          resolve(data);
          //resolve(response.headers.get('redirectToken'));
        }
        return response.json();
      })
    })
  }

  validateSSOUser(url, type,verb) {

    return new Promise((resolve, reject) => {
      fetch(url, {
        method: verb,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Cache': 'no-cache'
        },
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          if (type === 'token') {
            resolve(response.headers.get('AfToken'));
          }
          return response.json();
        })
        .then(function (myJson) {
          resolve(myJson);
        })
        .catch(function (err) {
          resolve('unAuthorized');
        });
    });
  }

  checkAuthentication() {
    if (this.props.isAuthenticated === undefined) {
      this.props.auth.isAuthenticated = false;
      let ssoValidation = 'SizingEngine/validateSSOUser';
      let passportValidation = 'SizingEngine/Login';
      let tokenUrl = 'SizingEngine/Gettoken';
      let verbGet = 'GET';
      let verbPost = 'POST';
      let ssoType = 'SSO';
      let passportType = 'Passport';
      let tokenType = 'token';
      let unAuthorized = 'unAuthorized';

      let ssoLogOut = localStorage.getItem(logOutAttribute);
      
      let hpe_com = 'hpe.com';
      let hpe_corp = 'hpecorp';
      let isNonHPECOMDomain = window.location.href.indexOf(hpe_com) < 0 && window.location.href.indexOf(hpe_corp) < 0;
      let queryParameter = queryString.parse(window.location.search);
      if (isNonHPECOMDomain || (queryParameter.reference !== undefined && (document.referrer.indexOf(hpe_com) > 0 || document.referrer.indexOf(hpe_corp) > 0))) {
        this.validateSSOUser(serviceUrl + tokenUrl, tokenType)
          .then((result) => {
            this.setState({ token: result });
            this.props.fetchDefaultData();
            this.props.onLocalLogin(this.getDefaultUser());
          });
      }
      else if (ssoLogOut == null) {
        this.props.onpassportLoggingIn();
        this.validateSSOUser(serviceUrl + ssoValidation, ssoType, verbGet)
          .then((result) => {
            if (result !== unAuthorized) {
              var loggedInUser = result.loggedInUser;
              this.validateSSOUser(serviceUrl + tokenUrl, tokenType, verbGet)
                .then((result) => {
                  this.setState({ token: result });
                  this.props.fetchDefaultData();
                  this.props.onupdateSSOUser(loggedInUser);
                  this.props.auth.ssoUser = true;
                });
            }
            else {
              this.validateSSOUser(serviceUrl + passportValidation, passportType, verbPost)
                .then((result) => {
                  if (result !== unAuthorized) {
                    var passportResult = result;
                    this.validateSSOUser(serviceUrl + tokenUrl, tokenType, verbGet)
                      .then((result) => {
                        this.setState({ token: result });
                        this.props.fetchDefaultData();
                        this.props.onupdateSSOUser(passportResult);
                      });
                  } else if (result === unAuthorized) {
                    this.props.onserverError();
                  }
                });
            }
          });
      }
    }
  }

  reloadListener() {
    if (window.performance) {
      if (performance.navigation.type == 1) {
        window.location.href = appUrl;
      } else {
      }
    }
  }

  // getUserPassportData(hppSession, isNonHPECOMDomain, isDigitalTokenUsed) {
  //   let UserInfo = undefined;
  //   if (isNonHPECOMDomain === true) {
  //     UserInfo = {
  //       preferredlanguage: 'en',
  //       hpclname: 'default@test.com', // For non domain hosted websites 
  //       hpclidnumber: 'd56c5196274c7f1bc5a6093c79e1822e', // Random ID
  //       hpresidentcountrycode: 'US',
  //       sn: 'default',
  //       givenname: 'default',
  //       email: 'default@test.com',
  //       createtimestamp: '2019-01-30 13:22:03',
  //       modifytimestamp: '2019-01-30 13:22:03',
  //       clang: 'US-en',
  //       isDigitalBadgeuser: 'True'
  //     }
  //   }
  //Digital token case
  //   else if (isDigitalTokenUsed) {
  //     UserInfo = {
  //       preferredlanguage: 'en',
  //       hpclname: Cookies.get('uid'),
  //       hpclidnumber: Cookies.get('employeeNumber'),
  //       hpresidentcountrycode: Cookies.get('cc'),
  //       sn: Cookies.get('sn'),
  //       givenname: Cookies.get('givenName'),
  //       email: Cookies.get('uid'),
  //       createtimestamp: '',
  //       modifytimestamp: '',
  //       clang: 'US-en',
  //       isDigitalBadgeuser: 'True'
  //     }
  //   }
  //   else if (!Cookies.has('u_d') || Cookies.get('u_d') === undefined
  //     || Cookies.get('u_d') === null || Cookies.get('u_d') === '') {
  //     if (this.props.userDataFetchState === undefined) {
  //       this.props.getUserBasicInfo(hppSession);
  //       return;
  //     }
  //     if (this.props.userDataFetchState === 'FETCHED_SUCCESS') {
  //       UserInfo = this.props.userData;
  //     }
  //   }
  //   else {
  //let cookieData = '=?UTF-8?B?PCV1c2VyYXR0cj0icHJlZmVycmVkbGFuZ3VhZ2U9ZW58aHBjbG5hbWU9anVuYWlkYWhtZWQuYW5zYXJpQGhwZS5jb218aHBjbGlkbnVtYmVyPTBhMDkwZDlhNzQ1OTFhMGQ0MDg1NTdiZTY2NTRiNWVhfGhwcmVzaWRlbnRjb3VudHJ5Y29kZT1JTnxzbj1BbnNhcml8Z2l2ZW5uYW1lPUp1bmFpZHxlbWFpbD1qdW5haWRhaG1lZC5hbnNhcmlAaHBlLmNvbXxjcmVhdGV0aW1lc3RhbXA9MjAxOS0wMS0wNCAxNDo0Njo0NHxtb2RpZnl0aW1lc3RhbXA9MjAxOS0wMS0wNCAxNDo0Njo0NHxjbGFuZz1JTi1lbg==?=';
  //     let cookieData = undefined;
  //     //hppSession === undefined ? 'undefined' : hppSession;
  //     if (!Cookies.has('u_d')) {
  //       return;
  //     }
  //     let temp = Cookies.get('u_d');
  //     if (temp === undefined || temp === null) {
  //       return;
  //     }
  //     try {
  //       cookieData = temp;

  //       var encodedTextRegex =
  //         '(?:=\\?UTF-8\\?B\\?)(\\S*)(?:\\?=)';

  //Extract encoded text from cookie content

  //       var encodedContent =
  //         cookieData.match(encodedTextRegex)[1];

  //Decode encoded text from cookie content

  //       var decodedContent =
  //         Base64.decode(encodedContent);

  //       var dataRegex =
  //         '(?:preferredlanguage=)(\\S*)(?:\\|)(?:hpclname=)(\\S*)(?:\\|)(?:hpclidnumber=)(\\S*)(?:\\|)(?:hpresidentcountrycode=)(\\S*)(?:\\|)(?:sn=)(\\S*)(?:\\|)(?:givenname=)(\\S*)(?:\\|)(?:email=)(\\S*)(?:\\|)(?:createtimestamp=)([\\d\\D]*)(?:\\|)(?:modifytimestamp=)([\\d\\D]*)(?:\\|)(?:clang=)([\\D]*)';

  //Extract authenticated email id from decoded text from cookie content

  //       var userDetails =
  //         decodedContent.match(dataRegex);

  //       UserInfo = {
  //         preferredlanguage:
  //           userDetails[1],
  //         hpclname:
  //           userDetails[2],
  //         hpclidnumber:
  //           userDetails[3],
  //         hpresidentcountrycode:
  //           userDetails[4],
  //         sn: userDetails[5],
  //         givenname:
  //           userDetails[6],
  //         email: userDetails[7],
  //         createtimestamp:
  //           userDetails[8],
  //         modifytimestamp:
  //           userDetails[9],
  //         clang: userDetails[10],
  //         isDigitalBadgeuser: 'False'
  //       };
  //     }
  //     catch (e) { return; }
  //   }

  //   this.props.onLocalLogin({
  //     userName: UserInfo.givenname,
  //     lastName: UserInfo.sn,
  //     password: undefined,
  //     preferredLanguage: UserInfo.preferredlanguage,
  //     hpclname: UserInfo.hpclname,
  //     hpclidnumber: UserInfo.hpclidnumber,
  //     hpresidentcountrycode: UserInfo.hpresidentcountrycode,
  //     email: UserInfo.email,
  //     createtimestamp: UserInfo.createtimestamp,
  //     modifytimestamp: UserInfo.modifytimestamp,
  //     clang: UserInfo.clang
  //   });
  //   this.setState({ Country: UserInfo.clang });

  //   var dataToSave = {
  //     "firstName": UserInfo.givenname,
  //     "lastName": UserInfo.sn,
  //     "emailId": UserInfo.email,
  //     "uniqueId": UserInfo.hpclidnumber,
  //     "countryCode": UserInfo.hpresidentcountrycode,
  //     "countryLanguage": UserInfo.clang,
  //     "preferredLanguage": UserInfo.preferredlanguage,
  //     "userId": UserInfo.hpclname,
  //     "accountCreationDate": UserInfo.createtimestamp,
  //     "accountModificationDate": UserInfo.modifytimestamp,
  //     "authChannel": 'HPE Passport',
  //     "isDigitalBadgeuser": UserInfo.isDigitalBadgeuser,
  //     "sessionID": hppSession
  //   }
  //   this.props.onSaveUserData(dataToSave);
  // }


  getUserName() {
    return 'test@test.com';
  }


  //Update user Country 
  setUserDefaultCountry() {
    try {
      if (this.props.isAuthenticated === true && this.props.countries != '') {
        //let countryCode = this.state.Country.split('-')[0];
        let countryCode = this.props.auth.userData.clang.split('-')[0];
        let countryName = this.props.countries.Countries.Country.filter(p => p.PricingCountry === countryCode)[0].Name
        if (this.props.country !== countryName && this.props.userData.defaultCountrySet !== true) {
          this.props.onCountryChange(countryName);
          this.props.userData.defaultCountrySet = true;
        }
      }
    }
    catch (e) { }
  }

  // checkAuthentication() {
  //   let url = window.location.href;
  //   let isNonHPECOMDomain = url.indexOf('hpe.com') < 0;
  //   let letDigitialToken = false;
  //   if (!Cookies.has('HPPSESSION') && isNonHPECOMDomain !== true) {
  //     this.setState({ isAuthenticated: false }); // false
  //     return;
  //   }
  //   let count = Cookies.get('HPPSESSION');
  //   let DigitalToken = Cookies.get('HPPFEDSESSION');
  //   let isDigitalTokenUsed = false;
  //   let logOut = Cookies.get('SizerLogout');


  //   //isNonHPECOMDomain = false;

  //   let redirectedFromPassportSite = url.indexOf('hpappid=' + landingUrl) >= 0;

  //   if (DigitalToken !== undefined && DigitalToken !== null && DigitalToken !== 'LOGGEDOFF') {
  //     isDigitalTokenUsed = true;
  //   }

  //   if (isNonHPECOMDomain || (count !== undefined && count !== null && count !== 'LOGGEDOFF' && (logOut === undefined || logOut === null || logOut === '' || redirectedFromPassportSite))) {
  //     this.setState({ isAuthenticated: true }); // true
  //     this.getUserPassportData(count, isNonHPECOMDomain, isDigitalTokenUsed);
  //   }
  //   else {
  //     this.setState({ isAuthenticated: false }); // false
  //   }
  // }

  render() {
    let inputs = ['Start Sizing', 'Processing the Inputs', 'Generating Server Configurations',
      'Generating Processor Configurations', 'Generating Memory Configurations',
      'Generating Storage Configurations', 'Generating Solution Summary'];

    let Time = 1000;
    if (said === "CS750VirtSizer") {
      Time = 23000;
    }else if(said === "EPAvNext") {
      Time = 12000;
      inputs = ['Start Sizing', 'Processing the Inputs', 'Generating Server, Processor, Memory and Storage Configurations',
      'Generating Solution Summary'];
    }else if(said === "SAP"){
       Time = 10000;
      inputs = ['Start Sizing', 'Processing the Inputs', 'Generating Server, Processor, Memory and Storage Configurations',
      'Generating Solution Summary'];
    }else if(said === "SAPHANA"){
       if(this.props.workload.UserInputs && this.props.workload.UserInputs.Environments.WorkloadType === 'SAPHANA'){
         Time = 8000;
       } else{
        Time = 16000;
       }
      inputs = ['Start Sizing', 'Processing the Inputs', 'Generating Server, Processor, Memory and Storage Configurations',
      'Generating Solution Summary'];
    }
    let field = '';
    if (this.state.token !== '') {
      field = <input id="__antiForgeryToken"
        name="antiForgeryToken" type="hidden"
        value={this.state.token} />

    }
    this.setUserDefaultCountry();
    //if (this.props.userDataFetchState === 'FETCHED_SUCCESS' && this.props.isAuthenticated !== true) {
    //  this.checkAuthentication();
    //}
    var DefInputs = this.props.DefaultInputs;
    if (DefInputs === undefined) {
      DefInputs = {};
    } else {
      this.state.isLoading = false;
    }

    var layer = '';
    var idlelayer = ''
    if (this.props.isLoading) {
      if (this.props.LoadingMsg !== "Please wait while Sizing the Solution.") {
        layer = <Layer style={{ zIndex: '500 !important' }}>
          <Box direction='row' style={{ padding: '40px', backgroundColor: '#425563' }} size='medium' pad={{ 'between': 'small' }}>
            <Spinning size='small' className='spinnerStyle' />
            <Heading tag='h5' margin='none' style={{ color: 'white' }}>{this.props.LoadingMsg}</Heading>
          </Box>
        </Layer>
      }
      else {
        layer = <ProgressBar inputs={inputs} TimeInterval={Time} />
      }
    }
    else {

    }
    if (idletimeoutpopup) {
      idlelayer = <Layer style={{ zIndex: '500 !important', }}>
        <Box style={{ backgroundColor: 'white' }} size='medium' pad={{ 'between': 'small' }}>
          <Box style={{ padding: '10px', backgroundColor: '#425563', color: 'white' }} >
            <Heading tag='h5' margin='none' style={{ color: 'white' }}>Application Timed Out</Heading>
          </Box>
          <Box justify='between' margin="none" pad="small" align='center' style={{ display: "block" }}>
            <Paragraph>The Application has been timed out due to inactivity. Please click below button to refresh.</Paragraph>
            <Button id='refreshButton' style={{ backgroundColor: '#425563', color: 'white', width: '50%', marginLeft: '28%' }} label="Refresh" onClick={this.Refresh} />
          </Box>
        </Box>
        {/*<Box  justify='between'  margin="none" pad="small"  align='center'>                   
                        <Button  full={true} label="Refresh"  onClick={this.Refresh}/>    
                    </Box>*/}
      </Layer>
    }
    let componentToBeRendered = Home;
    if (this.state.showGRView) {
      componentToBeRendered = SolutionLayout;
    } else if (this.state.showSolutionPreview) {
      componentToBeRendered = renderSolutionPreview;
    } else if (this.state.showMetricsData) {
      componentToBeRendered = renderMetricsData;
    } else if (this.state.showSAPLookUp) {
      componentToBeRendered = renderSAPLookUp;
    } else if(this.state.showCompareSol){
      componentToBeRendered = renderCompareSol;
    } else if(this.state.showGlGrowth){
      componentToBeRendered = renderGLGROWTH;
    }
    let quePar = queryString.parse(window.location.search);
    let ignoreSSET = false;
    if(quePar!==undefined && quePar.reference!==undefined){
      ignoreSSET = true;
    }
    return (
      <Beforeunload onBeforeunload={
        //  this.props.isAuthenticated === true ? () => "You'll loose your data!" : undefined
        function (e) {
          let idsToIgnore = [
            'refreshButton',
            'mailTo',
            'SignInButton',
            'backToSSETyes',
            'sizeWorkloadBtn',
            'start-guidance',
            'logOutYes'
          ]
          if ((e.srcElement.activeElement.attributes['id'] !== undefined && idsToIgnore.indexOf(e.srcElement.activeElement.attributes['id'].value) !== -1) ||
            this.props.isAuthenticated === false ||
            document.getElementById('sizeWorkloadBtn') !== null) {
            return undefined;
          }
          else return "You'll loose your data!";
        }.bind(this)
      }>
        <IdleTimer
          ref={ref => { this.idleTimer = ref } }
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={50}
          timeout={3600000} />
        <App centered={false}>
          <Box id="everything" className="everything" >
            {field}
            <Box id="content" >
              <Box id="header" className="header"></Box>
              {layer}
              {idlelayer}
              {/*     <Header colorIndex="neutral-1" className="HeaderPart" fixed={false} style={{width:'100% !import',borderBottom: '1px solid rgb(66, 85, 99)'}}>
                <Box pad="none" margin="none" direction="row" style={{width:'100%'}}>
                    <Box basis="1/4" pad="small" className="Logo">
                       <BrandHpeStack size='xlarge'  type='logo'/>
                    </Box>
                    <Box basis="3/4" pad="small">
                      <Headline align="start" margin="small" size="small" strong={true}>
                        {DefInputs["SizerCaption"]}
                      </Headline>
                    </Box>
                </Box>
         </Header> */}

              <Router basename={basename}>
                <Switch>
                  <PrivateRoute authed={this.props.isAuthenticated} exact={true} path='/' component={componentToBeRendered} history={history} grPropData={this.state.grProps} solutionPreviewPropData={this.state.solutionPreviewProps} metricsDataPropData={this.state.metricsDataProps} SAPLookUpPropData={this.state.SAPLookUpProps} GLGrowthPropData={this.state.GlGrowthProps} compareSolPropsData={this.state.compareSolProps} ignoreSSET={ignoreSSET} />
                  {/*<PrivateRoute authed={this.props.isAuthenticated} path='/Login' component={LoginScr} history={history} />
                  <PrivateRoute authed={this.props.isAuthenticated} path='/Registration' component={RegistrationScr} history={history} />
                  <PrivateRoute authed={this.props.isAuthenticated} path='/ResetPassword' component={ResetPasswordScr} history={history} />
                  <PrivateRoute authed={this.props.isAuthenticated} path='/ForgotPassword' component={ForgotPasswordScr} history={history} />
                  <PrivateRoute authed={this.props.isAuthenticated} path='/ValidateUser' component={ValidateUserScr} history={history} />*/}

                  <PrivateRoute authed={this.props.isAuthenticated} path='/Home' component={Home} history={history} />
                  <PrivateRoute authed={this.props.isAuthenticated} path='/Build' component={Build} history={history} />
                  <PrivateRoute authed={this.props.isAuthenticated} component={Home} />


                  {/*
                <Route path='/ExampleConfig/' component={ExampleConfigPlaceHolder} history={history} />
                <Route path='/LoadWorkload' component={LoadWorkload} />
              */}
                </Switch>
              </Router>
              <Box id="footer" className="footer"></Box>
            </Box>
          </Box>
        </App>
      </Beforeunload>
    );
  }
}

const mapStateToProps = (state) => {
  let isLoading = state.sessions.isLoading;
  let LoadingMsg = state.sessions.LoadingMsg;
  if (state.sessions.isLoginPending === true) {
    isLoading = true;
    LoadingMsg = state.sessions.LoginMsg;
  }
  return {
    DefaultInputs: state.sessions.sessionDefaults.inputs.Sizers,
    isLoading: isLoading,
    LoadingMsg: LoadingMsg,
    countries: state.sessions.sessionDefaults.Countries,
    country: state.sessions.Country,
    workload : state.sizerWorkload.workload,
    userData: state.auth.userData,
    userDataFetchState: state.auth.userDataFetchState,
    isAuthenticated: state.auth.isAuthenticated,
    auth: state.auth,
    sessionsState: state.sessions,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDefaultData: () => {
      dispatch(fetchDefaultData());
    },
    onLocalLogin: (userData) => {
      dispatch(checkLogin(userData));
    },
    //getUserBasicInfo: (hppSession) => {
    //  dispatch(getUserBasicInfo(hppSession));
    //},
    onCountryChange: (country) => {
      dispatch(updateCountry(country))
    },
    onSaveUserData: (userInfo) => {
      dispatch(saveUserData(userInfo))
    },
    onLogin: () => {
      dispatch(login())
    },
    onSSOLogin: () => {
      dispatch(ssoLogin());
    },
    onupdateSSOUser: (inputs) => {
      dispatch({ type: 'LOGIN_SUCCESS', payload: inputs });
    },
    onpassportLoggingIn: () => {
      dispatch({ type: 'LOGIN_PENDING', payload: '' });
    },
    onserverError: () => {
      dispatch({ type: 'SERVER_ERROR', payload: '' });
    }
  };
};

//  const PrivateRoute = ({component: Component, authed, ...rest}) => {
//   return (
//     <Route
//       {...rest}
//       render={(props) => authed === true
//         ? <Component {...props} />
//         : <Redirect to={{pathname: '/Registration', state: {from: props.location}}} />} />
//   )
// };

const clearSessions= ()=>{
  localStorage.removeItem(logOutAttribute);
}

const isSafe = (param) => {
  return param;
}
const closeButton=()=>{
  if(window.sessionStorage.getItem("IsParent")==="True"){
    window.open(window.location.protocol+'//'+window.location.host,'_self')
  }else{
   window.top.close();
  }
}
const continePopup = ()=>{
  return(
    <Box direction="column" margin="none" pad="none">
    <Box direction="row" colorIndex="neutral-1" margin="none" pad="small" separator="bottom">
      <Box direction="row" margin="none" pad="none" align='start'>
        <Heading tag="h4" strong={true} style={{ marginBottom: '0px', color: '#01a982' }}>Notification</Heading>
      </Box>

    </Box>
    <Box margin="none" pad="small">
      <Heading tag="h6" strong={true} style={{ margin: '4px 0px' }}>Information</Heading>
      <Paragraph style={{ margin: '2px 0px' }}>Thank you for your interest in '{title}'.To provide a consistent user experience with presales tools,  All the individual sizer applications under presales tools category are now consolidated into Solution Sales Enablement Tool (SSET) with enhanced functionality. Please click the “Continue to SSET” button to navigate to SSET and follow the steps provided below to access the workload/infrastructure options for sizing your solution.</Paragraph>
      <Paragraph style={{ margin: '2px 0px' }}>To access the sizing tool through SSET:</Paragraph>
      <Paragraph style={{ margin: '2px 0px' }}>1. Login with your HPE Employee (SSO) or Partners (Passport) credentials</Paragraph>
      <Paragraph style={{ margin: '2px 0px' }}>2.	If you are a first time SSET user, you need to request an access to the tool</Paragraph>
      <Paragraph style={{ margin: '2px 0px' }}><ul style={{marginBottom: '0px',marginLeft: '30px'}}><li>An HPE SSET admin will validate the request and will notify the user by email of the status of the access request</li></ul></Paragraph>
      <Paragraph style={{ margin: '2px 0px' }}>3.	On the landing page, click ‘Start a new Guidance’ button</Paragraph>
      <Paragraph style={{ margin: '2px 0px' }}>4.	On the dashboard page, select the Enterprise Solutions category. </Paragraph>
      <Paragraph style={{ margin: '2px 0px' }}>5.	Select the desired offering under Workload or Infrastructure Solutions and click Start.</Paragraph>
      <Paragraph style={{ margin: '2px 0px' }}>6.	Fill out the General Inputs and then click on the Expert Sizing button to launch the Sizer.</Paragraph>
      <Paragraph style={{ margin: '2px 0px' }}>For more information refer SSET User Guide found under the Help icon in the SSET user interface or send an email to <Anchor id='mailTo' href={"mailto:sset@hpe.com?Subject=" + encodeURI(title) + "%20(Online%20Client)"} style={{ textDecoration: "underline" }}>sset@hpe.com</Anchor>.</Paragraph>
      <Box alignSelf='center' direction='row' margin='small'justify='between' style={{width:'70%'}}>
        <Button size='small' primary={true} label='Continue to SSET ' onClick = {clearSessions} id='SignInButton' href={ssetURL} target='_self' style={{padding:'5px'}}></Button>
        <Button size='small' primary={true} label='Close ' onClick={closeButton} id='ButtonClose'  /* href={window.location.protocol+'//'+window.location.host} */  style={{padding:'5px'}}></Button>                
      </Box>
    </Box>
  </Box>
  );
}

const PrivateRoute = ({ component: Component, grPropData, solutionPreviewPropData, metricsDataPropData, SAPLookUpPropData, GLGrowthPropData, compareSolPropsData, authed,ignoreSSET, ...rest }) => {
  //var redirectUrl = 'https://cf.passport.hpe.com/hppcf/login.do?hpappid=' + landingUrl + '&applandingpage=https%3A%2F%2F' + redirection_Link + '%2F' + basename.replace('/', '');
  var redirectUrl = 'https://cf.passport.hpe.com/hppcf/login.do?hpappid=' + landingUrl + '&applandingpage=https://' + redirection_Link + '/' + basename.replace('/', '');
  redirectUrlSSO = serviceUrl+'SizingEngine/SSOLogin';
  redirectUrl = encodeURI(redirectUrl);
  return (
    <Route
      {...rest}
      render={(props) => authed === true
        ? <Component   {...isSafe(props) } grProps={grPropData}  solutionPreviewProps={solutionPreviewPropData} metricsDataProps={metricsDataPropData} SAPLookUpProps={SAPLookUpPropData} GlGrowthProps={GLGrowthPropData} compareSolProps={compareSolPropsData} />//{...props}   <Login/>}/>
        :hideforSSET==='True' ||ignoreSSET || window.sessionStorage.getItem("isReload")==="True"? <Layer style={{ zIndex: '500 !important' }}>
        <Box direction='row' style={{ padding: '40px', backgroundColor: '#425563' }} size='medium' pad={{ 'between': 'small' }}>
          <Spinning size='small' className='spinnerStyle' />
          <Heading tag='h5' margin='none' style={{ color: 'white' }}>{'Please wait while loading the data'}</Heading>
        </Box>
      </Layer>
        :<Layer style={{ width: '600px' }} className="AuthenticationLayer" >
          {continueToSSET==='True'?continePopup()
          :
          <Box direction="column" margin="none" pad="none">
            <Box direction="row" colorIndex="neutral-1" margin="none" pad="small" separator="bottom">
              <Box direction="row" margin="none" pad="none" align='start'>
                <Heading tag="h4" strong={true} style={{ marginBottom: '0px', color: '#01a982' }}>Sign in</Heading>
              </Box>

            </Box>
            <Box margin="none" pad="small">
              <Heading tag="h6" strong={true} style={{ margin: '4px 0px' }}>Authentication</Heading>
              <Paragraph style={{ margin: '2px 0px' }}>Thanks for visiting '{title}'. To authenticate user credentials, you will be redirected to HPE authentication website. Once authenticated you will be redirected back to this site. Press Sign in button to continue.</Paragraph>
              <Box alignSelf='center' direction='row' margin='small'justify='between' style={{width:'70%'}}>
                <Button size='small' primary={true} label='HPE Employee Login ' onClick = {clearSessions} id='SignInButton' href={redirectUrlSSO} style={{padding:'5px'}}></Button>
                <Button size='small' primary={true} label='HPE Passport Login ' onClick = {clearSessions} id='SignInButton' href={redirectUrl} style={{padding:'5px'}}></Button>                
              </Box>
            </Box>
            </Box> }
        </Layer>} />

  )
};

export default connect(mapStateToProps, mapDispatchToProps)(MyApp);



// WEBPACK FOOTER //
// ./src/MyApp.js